import { RestrictionConfigurations, RestrictionType } from '../models';

export function isBuyerAccountInRestrictionList(
  buyerAccountNumbers: string[],
  configuration: RestrictionConfigurations[],
  restrictionType: RestrictionType,
) {
  return buyerAccountNumbers.some((buyerAccount) =>
    configuration.some(
      (x) =>
        x.buyerAccount === buyerAccount &&
        x.restrictionType === restrictionType,
    ),
  );
}
